import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { EProjectType } from '../../../enum/project';
import { IProjectItemProps } from './IProjectItem';
import './ProjectItem.scss';

const ProjectItem = (props: IProjectItemProps) => {
    const { t, i18n } = useTranslation();
    const options: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', day: 'numeric', month: 'long', hour: 'numeric', minute: 'numeric' };
    const date = new Date(props.project.lastModified).toLocaleDateString(i18n.language, options);
    // Reason: projectInfo is null for unconfigured projects from backend
    const projectType = props.project.projectInfo?.data?.type;
    const type = projectType ? t(EProjectType[projectType]) : '';

    const handleMainClick = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            props.onClick?.(e as unknown as React.MouseEvent<HTMLDivElement>);
        }
    };

    const handleDeleteClick = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            props.onDelete?.(e as unknown as React.MouseEvent<HTMLElement>);
        }
    };

    return (
        <>
            <div className="d-flex justify-content-between p-1 cursor-pointer tableRow">
                <div className="w-100 d-flex" onClick={props.onClick} onKeyDown={handleMainClick} role="button" tabIndex={0}>
                    <div className="w-30 me-5 ellipsis-simple-line name" title={props.project.projectName}>
                        {props.project.projectName}
                    </div>
                    <div className="w-30 me-5">{date}</div>
                    <div className="w-30">{type}</div>
                </div>
                <i className="fa-solid fa-trash" onClick={props.onDelete} onKeyDown={handleDeleteClick} role="button" tabIndex={0} aria-label={t('delete_project') || 'Delete project'} />
            </div>
            <hr />
        </>
    );
};

export default ProjectItem;
